const errorCodes = {
  UserAccountExpiredException: 52,
  TokenMalformedException: 61,
  TokenExpiredException: 62,
  TokenInvalidException: 63,
  InvalidRequestDataException: 102,
  InvalidBusinessProfileRequested: 112,
  ForbiddenBusinessProfileRequested: 113,
  ForbiddenPortalRequested: 56,
  Unauthorized: 401,
  Forbidden: 403,
  RefreshTokenExpired: 76
};

export const guardrailsArea = {
  NSFW: 1001,
  HATE_SPEECH: 1002,
  VIOLENCE_SELF_HARM: 1003,
  CSAM: 1004,
  INSTRUCTION_OVERRIDE: 1005,
  ASSET_POLICY: 1006
}

export default errorCodes;
